module.exports = __webpack_public_path__ + "media/images/exam-c871e2333d56082bf1cebdd22052b6e6.png";